import { Country } from '@angular-material-extensions/select-country';
export const countryUS: Country = {
  name: '+1',
  alpha2Code: 'US',
  alpha3Code: 'USA',
  numericCode: '1',
  callingCode: '1',
};
export const countryPH: Country = {
  name: '+63',
  alpha2Code: 'PH',
  alpha3Code: 'PH',
  numericCode: '63',
  callingCode: '63',
};
